import "./notificaitons.css";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { markNotificaitonRead } from "../../api/modules/b2droppie.class";

const Notifications = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const notification = location.state?.notification;
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  useEffect(() => {
    const markAsRead = async () => {
      if (notification?.id) {
        try {
          const payload = { id: notification.id };
          const response = await markNotificaitonRead(payload);
        } catch (error) {
          console.error("❌ Error marking notification as read:", error);
        }
      }
    };

    markAsRead();
  }, [notification]);

  if (!notification) {
    return (
      <div
        className={`container my-4 text-center ${
          isDarkMode ? "text-light" : "text-dark"
        }`}
      >
        <h4>No notification data found.</h4>
        <button
          onClick={() => navigate(-1)}
          className="w-10 w-md-100 filled-medium-deep-yellow-btn-dark"
        >
          Go Back
        </button>
      </div>
    );
  }

  const data = notification.data;

  return (
    <div
      className={`container mb-4 mt-5 border-0 rounded p-0 ${isDarkMode ? "dark" : "light"}`}
    >
      <Card
        className={`natification-container p-3 shadow-sm border-0 ${
          isDarkMode ? "text-light" : "text-dark"
        }`}
      >
        <h4
          className={`fw-semibold text-capitalize mb-3 ${
            isDarkMode ? "text-light" : "text-dark"
          }`}
        >
          {data?.status?.replace(/_/g, " ")}
        </h4>

        <p className={`fs-5 ${isDarkMode ? "text-secondary" : "text-muted"}`}>
          {data?.message}
        </p>

        {data?.verification_code && (
          <p className={`fs-6 ${isDarkMode ? "text-info" : "text-secondary"}`}>
            Code: <b>{data?.verification_code}</b>
          </p>
        )}

        <div className="mt-4 d-end">
          <button
            onClick={() => navigate(-1)}
            className={`w-10 w-md-100 ${
              isDarkMode
                ? "deep-primary-monochrome-btn-dark"
                : "outlined-medium-deep-purple-btn-light"
            }`}
          >
            ← Go Back
          </button>
        </div>
      </Card>
    </div>
  );
};

export default Notifications;
